// Chunk array into array of arrays, each array having chunkSize length
export function chunkArray(array, chunkSize) {
  return [].concat.apply(
    [],
    array.map(function(elem, i) {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
    })
  );
}

export function checkAccountEditPermission({permissions, currentUser}) {
  const currentUserID = currentUser.get("_id");
  return (
    permissions.toList().filter(permission => {
      return permission.user_id === currentUserID && permission.permissions.edit.account;
    }).size > 0
  );
}

export function getPlaceInfo(app, placeIDs) {
  const {facilityId, buildingId, floorId, markerId} = placeIDs;
  const facilities = app.state.get("facilities");
  const buildings = app.state.get("buildings");
  const floors = app.state.get("floors");
  const markers = app.state.get("markers");
  const facility = app.state.getIn(["facilities", facilityId]);
  const building = app.state.getIn(["buildings", buildingId]);
  const floor = app.state.getIn(["floors", floorId]);
  const marker = app.state.getIn(["markers", markerId]);
  return {
    facilities,
    facility,
    buildings,
    building,
    floors,
    floor,
    markers,
    marker
  };
}



// WEBPACK FOOTER //
// ./src/components/Utilities/index.js